import getCountryPrefix from 'Jsx/Utils/getCountryPrefix';

export const COUNTRY_PREFIX = getCountryPrefix();

export const API_FROM_GLOBAL =
  typeof window !== 'undefined' && window.crehanaApiUrl;

export const GRAPH_ENDPOINT = '/api/v2/graph/';

export const GRAPH_ENDPOINT_AUTH = '/api/v2/graph/auth/';

export const GRAPH_ENDPOINT_PAYMENTS = '/api/v2/graph/payments/';

export const GRAPH_ENDPOINT_B2B = '/api/v2/graph/b2b/';

export const GRAPH_ENDPOINT_PRIVATE = '/api/v2/graph/private/';

export const GRAPH_ENDPOINT_SEARCH = '/api/v2/graph/search/';

export const GRAPH_ENDPOINT_V3 = '/api/v3/graph/';

export const GRAPH_ENDPOINT_V4 = '/api/graph/';

export const BASE_API_URL =
  API_FROM_GLOBAL || process.env.BASE_API_URL || GRAPH_ENDPOINT;

export const CREDENTIALS = process.env.BASE_API_URL ? 'include' : 'same-origin';
